export default __webpack_public_path__ + "static/media/promo_00.e860dedb.jpg";